import { map, find, omit } from "lodash";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database, storage } from "../../config/firebaseConfig";
import { v4 as uuidV4 } from "uuid";

function incrementBase36(id) {
  return (parseInt(id, 36) + 1).toString(36).padStart(4, "0");
}

export const fetchSlingsAsync = createAsyncThunk(
  "slingInventory",
  async (id, thunkAPI) => {
    try {
      if (!id) {
        await database
          .ref("/slingInventory")
          .orderByChild("deleted")
          .equalTo(null)
          .on("value", (snapshot) => {
            return thunkAPI.dispatch(fetchSlings(snapshot.val() || {}));
          });
      } else {
        await database.ref(`/slingInventory/${id}`).on("value", (snapshot) => {
          return thunkAPI.dispatch(fetchSlings({ [id]: snapshot.val() }));
        });
      }
      return;
    } catch (e) {
      throw e;
    }
  }
);

export const deleteSlingAsync = createAsyncThunk(
  "slingDelete",
  async (id, thunkAPI) => {
    try {
      await database.ref(`/slingInventory/${id}`).update({ deleted: true });
      return thunkAPI.dispatch(removeSling(id));
    } catch (e) {
      console.log({ e });
    }
  }
);
export const updateSlingForm = createAsyncThunk(
  "slingUpdate",
  async (values, thunkAPI) => {
    try {
      let lastKey = "";

      const uploadFiles = await Promise.all(
        map(values.unsavedFiles, async (file) => {
          try {
            const filePath = `slings/${uuidV4()}/${file.name}`;
            const storageRef = storage.ref(filePath);
            //onst upload = storageRef.put(file.file);

            console.log({ file, filePath });
            const downloadUrl = await storageRef
              .put(file.file)
              .then(async (snapshot) => {
                const url = await snapshot.ref
                  .getDownloadURL()
                  .then((dl) => dl);
                return url;
              })
              .catch((error) => {
                console.log("Error with upload", error);
              });
            const returnObj = { ...file, filePath, downloadUrl, file: [] };
            return returnObj;
          } catch (e) {
            console.log({ e });
          }
        })
      );
      if (!values.id)
        lastKey = await database
          .ref("slingInventory")
          .orderByKey()
          .limitToLast(1)
          .once("value")
          .then((s) => Object.keys(s.val())[0]);
      const nextKey = lastKey && incrementBase36(lastKey);
      const dbKey = values.id || nextKey;
      const latestVisualFile = find(
        uploadFiles,
        (f) => f.uploadType === "visual"
      );
      const latestVisualDate = latestVisualFile?.date;
      const latestLoadFile = find(
        uploadFiles,
        (f) => f.uploadType === "loadTest"
      );
      const latestLoadDate = latestLoadFile?.date;
      const latestLoadCert = latestLoadFile?.cert;
      const updatedValues = {
        ...values,
        id: dbKey,
        unsavedFiles: [],
        files: [...(values.files || []), ...uploadFiles],
        visual: latestVisualDate || values.visual,
        cert: latestLoadCert || values.cert,
        loadTest: latestLoadDate || values.loadTest,
        oldCert: latestLoadCert ? values.cert || "" : values.oldCert || "",
      };
      return database.ref("slingInventory").child(dbKey).set(updatedValues);
    } catch (e) {
      throw e;
    }
  }
);

export const cancelFetchSlingsAsync = createAsyncThunk(
  "slingInventoryOff",
  async (_, thunkAPI) => {
    try {
      await database.ref("slingInventory").off();
      return;
    } catch (e) {
      throw e;
    }
  }
);

const slice = createSlice({
  name: "slings",
  initialState: {
    slings: {},
    status: "idle",
  },
  reducers: {
    fetchSlings: (state, action) => {
      state.slings = { ...action.payload };
      state.status = "idle";
    },
    removeSling: (state, action) => {
      state.slings = omit(state.slings, action.payload);
      state.status = "idle";
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchSlingsAsync.pending, (state) => {
          state.status = "pending";
        })
        .addCase(fetchSlingsAsync.fulfilled, (state, action) => {
          state.status = "idle";
        });
    },
  },
});

export default slice.reducer;

const { fetchSlings, removeSling } = slice.actions;
